import { render } from "./ModalRequest.vue?vue&type=template&id=abded4cc&scoped=true"
import script from "./ModalRequest.vue?vue&type=script&lang=js"
export * from "./ModalRequest.vue?vue&type=script&lang=js"

import "./ModalRequest.vue?vue&type=style&index=0&id=abded4cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abded4cc"]])

export default __exports__